import React from 'react'
import { Link } from 'react-router-dom';
import './styles.css';
import poolPartyIconNoBackground from './../assets/poolpartyNoBackground.png';

const NavBar = () => {

    const renderHeaderNav = () => (
    <div className='home-screen-headerNav-container'>
      <div className='icon-header-container'>
        <img className='home-screen-icon' src={poolPartyIconNoBackground} alt="Pool Party Social Club Icon" />
        <h1 className="app-title">Pool Party Social Club</h1>
      </div>

      <div className='home-screen-nav-buttons-container'>
        <Link to="/" className="nav-link">Home</Link>
        <Link to="/features" className="nav-link">Features</Link>
        <Link to="/download" className="nav-link">Download</Link>
        <Link to="/contact" className="nav-link">Contact</Link>
      </div>
    </div>
  );

  return (
    <div>
       {renderHeaderNav()}
    </div>
  )

}

export default NavBar